import { boolean, object, ref, string } from 'yup';
import { validateEmail } from './global';

export const loginValidation = (t) =>
  object().shape({
    email: string().matches(validateEmail, t('invalidEmail')).required(t('emailRequired')),
    password: string().required(t('PasswordRequired')),
  });

export const loginMobileValidation = (t) =>
  object().shape({
    mobile: string()
      .label('Phone number')
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t('telephoneError1'))
      .matches(/^(05)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t('telephoneError2'))
      .min(10)
      .max(10)
      .required(t('TelephoneRequired')),
  });

export const forgotEmailValidation = (t) =>
  object().shape({
    email: string()
      .matches(validateEmail, t('invalidEmail'))
      .required(t('emailRequired')),
  });

export const otpValidation = (t) =>
  object().shape({
    otp: string().required(t('Otp is required')),
  });

export const changePasswordValidation = (t) =>
  object().shape({
    password: string()
      .min(8, t('HasAtLeast8Characters'))
      .matches(/[A-Z]/, t('ContainsOneUppercaseLetter'))
      .matches(/[a-z]/, t('ContainsOneLowercaseLetter'))
      .matches(/[0-9]/, t('ContainsOneNumber'))
      .required(t('PasswordRequired')),
    confirmPassword: string()
      .oneOf([ref('password'), null], t('PasswordsMustMatch'))
      .required(t('ConfirmPasswordRequired')),
  });

export const registerEmailValidation = (t) =>
  object().shape({
  firstname: string()
    .required(t('FirstNameRequired'))
    .matches(
      /^[a-zA-Z\s]+$/,
      t('FirstNameInvalid') // Add a custom message for invalid input
    )
    .max(25, t('FirstNameTooLong')), // Add translation key for max length

  lastname: string()
    .required(t('LastNameRequired'))
    .matches(
      /^[a-zA-Z\s]+$/,
      t('LastNameInvalid') // Add a custom message for invalid input
    )
    .max(25, t('LastNameTooLong')), // Add translation key for max length
    email: string()
      .matches(validateEmail, t('invalidEmail'))
      .required(t('emailRequired')),
    mobile: string()
      .label('Phone number')
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t('telephoneError1'))
      .matches(/^(05)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t('telephoneError2'))
      .min(10)
      .required(t('TelephoneRequired')),
    password: string()
      .min(8, t('HasAtLeast8Characters'))
      .matches(/[A-Z]/, t('ContainsOneUppercaseLetter'))
      .matches(/[a-z]/, t('ContainsOneLowercaseLetter'))
      .matches(/[0-9]/, t('ContainsOneNumber'))
      .required(t('PasswordRequired')),
    confirmPassword: string()
      .oneOf([ref('password'), null], t('PasswordsMustMatch'))
      .required(t('ConfirmPasswordRequired')),
    acceptedTerms: boolean()
      .oneOf([true], t('You must accept the terms and conditions'))
      .required('Required'),
  });

export const registerMobileValidation = (t) =>
  object().shape({
    firstname: string().required(t('FirstNameRequired')),
    lastname: string().required(t('LastNameRequired')),
    password: string()
      .min(8, t('HasAtLeast8Characters'))
      .matches(/[A-Z]/, t('ContainsOneUppercaseLetter'))
      .matches(/[a-z]/, t('ContainsOneLowercaseLetter'))
      .matches(/[0-9]/, t('ContainsOneNumber'))
      .required(t('PasswordRequired')),
    confirmPassword: string()
      .oneOf([ref('password'), null], t('PasswordsMustMatch'))
      .required(t('ConfirmPasswordRequired')),
    mobile: string()
      .label('Phone number')
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t('telephoneError1'))
      .matches(/^(5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t('telephoneError2'))
      .min(9)
      .required(t('TelephoneRequired')),
  });
